import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=ab35fc52&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"
import style0 from "./Choose.vue?vue&type=style&index=0&id=ab35fc52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35fc52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab35fc52')) {
      api.createRecord('ab35fc52', component.options)
    } else {
      api.reload('ab35fc52', component.options)
    }
    module.hot.accept("./Choose.vue?vue&type=template&id=ab35fc52&scoped=true", function () {
      api.rerender('ab35fc52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/Choose.vue"
export default component.exports